import { EEligibilityStep } from "app/frontend/components/eligibility/constants";
import { useParams } from "app/frontend/hooks/useParams";

export const useEdit = () => {
    const { edit: edit_ }: { edit: string } = useParams();
    return Number(edit_) as EEligibilityStep;
};
